module.exports = __webpack_public_path__ + "Flag-582.29b51e296b308f6422656ab9a78cbb3d.svg";